module.exports = __webpack_public_path__ + "static/img/7.4f93f80.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/zh/7.png
// module id = f+tz
// module chunks = 0